import { FileText, FileSpreadsheet, Calculator, Sigma, TrendingUp, Wallet, LayoutDashboard, Receipt, Layers } from "lucide-react";

export const ICONES_MODULO = {
  FileSpreadsheet,
  Calculator,
  Sigma,
  TrendingUp,
  Wallet,
  LayoutDashboard,
  Receipt,
  Layers,
};

export const getIconeModulo = (nome) => ICONES_MODULO[nome] || FileText;
